import { combineReducers } from 'redux';

import { DUPLICATE_CHECKLIST_REQUEST } from 'modules/checklists/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import checklistId from './checklistId';
import visible from './visible';

const duplicate = combineReducers({
  visible,
  checklistId,
  isLoading: loading(DUPLICATE_CHECKLIST_REQUEST),
});

export type ChecklistUiDuplicateReducer = ReturnType<typeof duplicate>;

export default duplicate;
